import { render, staticRenderFns } from "./vFormMixin.js.vue?vue&type=template&id=f515f34c&"
import script from "./vFormMixin.js.vue?vue&type=script&lang=js&"
export * from "./vFormMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports